export default __webpack_public_path__ + "2ad477036b3d56120a8df1a987dba02e.png";